module.exports = __webpack_public_path__ + "img/icon_instagram_reel.b39f8a28.svg";